<mat-form-field>
  <mat-label>
    {{ ("poolerType" | i18n) || "Poolertyp" | titlecase }}
  </mat-label>
  <mat-select
    [ngModel]="selectedValue"
    (selectionChange)="selectionChanged($event.value)"
    name="poolerTypeSelect"
    [disabled]="isDisabled"
    data-cy="pooler-type-select">
    <mat-option [value]="undefined"> - </mat-option>
    <mat-option
      *ngFor="let poolerType of customerPoolerTypes$ | async"
      [value]="poolerType.id"
      [attr.data-cy]="'pooler-type-option-' + poolerType.id">
      {{ poolerType.displayName }}
    </mat-option>
  </mat-select>
  <mat-hint
    align="end"
    *ngIf="hintContent">
    <ng-container *ngTemplateOutlet="hintContent"></ng-container>
  </mat-hint>
</mat-form-field>
